export default "__VITE_ASSET__Bjyg9bNW__"